// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.json-view {
    color: #002b36;
    --json-property: #002b36;
    --json-index: #6c71c4;
    --json-number: #268bd2;
    --json-string: #cb4b16;
    --json-boolean: #2aa198;
    --json-null: #dc322f;
}
`, "",{"version":3,"sources":["webpack://./src/styles/react18_json_viewer.css"],"names":[],"mappings":"AAAA;IACI,cAAc;IACd,wBAAwB;IACxB,qBAAqB;IACrB,sBAAsB;IACtB,sBAAsB;IACtB,uBAAuB;IACvB,oBAAoB;AACxB","sourcesContent":[".json-view {\n    color: #002b36;\n    --json-property: #002b36;\n    --json-index: #6c71c4;\n    --json-number: #268bd2;\n    --json-string: #cb4b16;\n    --json-boolean: #2aa198;\n    --json-null: #dc322f;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
